import { HTTPDataError } from 'services/helpers/HTTPDataError'
import { signInErrors } from 'const/signInErrors'
import getBusinessErrorInResponse from './getBusinessErrorInResponse'

export const isAccountNotFoundError = (
  isErrorAuthenticate?: boolean,
  authenticateErrorData?: HTTPDataError
): boolean => {
  let result = false
  if (isErrorAuthenticate) {
    const { data } = authenticateErrorData
    result = !!getBusinessErrorInResponse(data, signInErrors)
  }
  return result
}
